"use client";
// components/animations/SlideInWrapper.js
import { useEffect, useRef } from "react";

const ANIMATIONS = {
  left: "slideFromLeft",
  right: "slideFromRight",
  top: "slideFromTop",
  bottom: "slideFromBottom",
};

export default function SlideInWrapper({
  children,
  direction = "left",
  delay = 0,
  duration = 0.8,
  className = "",
}) {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const animationName = ANIMATIONS[direction] || ANIMATIONS.left;
            entry.target.style.animation = `${animationName} ${duration}s ease-out ${delay}s forwards`;
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [direction, delay, duration]);

  return (
    <div ref={ref} className={`opacity-0 ${className}`}>
      {children}
    </div>
  );
}
